const guacamoleTrialsUrl: string = process.env.REACT_APP_GUACAMOLE_TRIALS_URL!;
const guacamoleSubsUrl: string = process.env.REACT_APP_GUACAMOLE_SUBS_URL!;

export { guacamoleTrialsUrl, guacamoleSubsUrl };
